module.exports = __webpack_public_path__ + "static/chat-0c08d955cbc5b1332e08db3a51e4ef00.svg";